import { connect } from 'react-redux';

import { changeTypes } from '@zapier/design-system-revenue';

import * as Account from 'app/entities/Account';
import * as Plan from 'app/entities/Plan';
import * as Profile from 'app/entities/Profile';
import AccountActions from 'app/account/AccountActions';
import AccountMenu from 'app/viewport/components/AccountMenu';
import BillingActions from 'app/billing/BillingActions';

const mapStateToProps = state => {
  const currentAccount = Account.selectors.all.currentAccount(state);
  const primaryAccountId = Account.selectors.all.primaryAccountId(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);

  return {
    accountId: primaryAccountId,
    email: Profile.selectors.email(currentProfile) || '',
    hasTeam: Account.selectors.isTeam(currentAccount) || false,
    isPlanMetered: Account.selectors.isPlanMetered(currentAccount) || false,
    isPaid: Account.selectors.isPaid(currentAccount) || false,
    isDeveloper: Profile.selectors.isDeveloper(currentProfile) || false,
    showTrialInfo:
      Account.selectors.isTrialing(currentAccount) &&
      !Account.selectors.isTrialingTeams(currentAccount) &&
      !Account.selectors.isTrialingCompanies(currentAccount),
    nextPlanTier: Plan.selectors.all.nextPlanTierByYear(state),
    numTasks: Account.selectors.numTasks(currentAccount) || 0,
    numTasksMax: Account.selectors.numTasksMax(currentAccount) || 0,
    numFreeTasksMax: Plan.selectors.numFreeMeteredTasks(
      Plan.selectors.all.currentPlan(state)
    ),
    numLiveZaps: Account.selectors.numLiveZaps(currentAccount) || 0,
    numLiveZapsMax: Account.selectors.numLiveZapsMax(currentAccount) || 0,
    planName: currentAccount
      ? `${Account.selectors.planName(currentAccount)}`
      : '',
    resetDate:
      Account.selectors.periodEndDate(currentAccount) ||
      new Date().toUTCString(),
    trialDaysLeft: Account.selectors.trialDaysLeft(currentAccount),
    userAvatarUrl: Profile.selectors.gravatarUrl(currentProfile),
    userName: Profile.selectors.normalizedNameOrLoading(currentProfile),
  };
};

const mapDispatchToProps = dispatch => ({
  onMount() {
    dispatch(AccountActions.loadAccount()).then(() =>
      dispatch(Plan.actions.loadCollection())
    );
  },
  upgradeToPlan(plan) {
    dispatch(BillingActions.selectPlan(plan, changeTypes.upgrade));
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onUpgradeClick: () =>
      dispatchProps.upgradeToPlan(stateProps.nextPlanTier.data),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AccountMenu);
